module.exports = __webpack_public_path__ + "img/1.da582d3f.png";